import {
  affiliateID,
  buyersByTypeList
} from '../../../../common/commonRequests';

export const filters = () => ({
  buyer: {
    name: 'buyer',
    type: 'select',
    label: 'Buyer',
    refreshOnFilter: true,
    options: () => {
      return buyersByTypeList(2, true);
    },
    value: '-1',
    inputWidth: 3,
    withinDateRange: true
  },
  affiliateID: {
    name: 'affiliateID',
    type: 'autocomplete',
    label: 'Affiliate',
    options: () => affiliateID(),
    value: 'all',
    inputWidth: 3
  }
});
